import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import useLoader from '@hooks/useLoader';
import { setMyInfoSpread } from '@stores/myInfo';
import { useSession } from 'next-auth/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaAngleRight } from 'react-icons/fa';
import { MdOutlineLanguage } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useCountry } from '../queries';

export default function LanguageMenu() {
  const { i18n, t } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const { status } = useSession();
  const { progressLoader, stopLoader } = useLoader();
  const dispatch = useDispatch();
  const { mutateAsync } = useCountry({
    onMutate: ({ country }) => {
      progressLoader();
      dispatch(setMyInfoSpread({ country }));
    },
    onSettled: () => {
      stopLoader();
    },
  });

  const handleMenuChange = async (value: string) => {
    if (status === 'authenticated') {
      await mutateAsync({ country: value });
    }
    i18n.changeLanguage(value);
    localStorage.setItem('lang', value);
    setCurrentLang(value);
  };

  return (
    <Menu placement="right-start" size="sm" matchWidth>
      <MenuButton as="button">
        <div className="flex gap-[6px] items-center font-bold text-lg">
          <MdOutlineLanguage />
          <span>{t('home:language_selection')}</span>
          <FaAngleRight />
        </div>
      </MenuButton>
      <MenuList>
        <MenuItem
          onClick={() => handleMenuChange('en')}
          className={`${
            currentLang === 'en' ? 'bg-primary-500 text-white' : ''
          }`}
        >
          English
        </MenuItem>
        <MenuItem
          onClick={() => handleMenuChange('th')}
          className={`${
            currentLang === 'th' ? 'bg-primary-500 text-white' : ''
          }`}
        >
          แบบไทย
        </MenuItem>
        <MenuItem
          onClick={() => handleMenuChange('id')}
          className={`${
            currentLang === 'id' ? 'bg-primary-500 text-white' : ''
          }`}
        >
          Bahasa Indonesia
        </MenuItem>
        <MenuItem
          onClick={() => handleMenuChange('ko')}
          className={`${
            currentLang === 'ko' ? 'bg-primary-500 text-white' : ''
          }`}
        >
          한국어
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
